import axios from 'api/axios'
import handleAxiosError from 'utils/handleAxiosError'

export interface GetTotalTeamCountParams {
	client?: string | undefined
}

export type GetTotalTeamCountResponse = Array<{
	_id: {
		teamName?: string
		active: boolean
	}
	count: number
}>

export const getTotalTeamCount = async (
	params: GetTotalTeamCountParams
): Promise<GetTotalTeamCountResponse> => {
	try {
		const { data } = await axios.get('v1/teams/management/insight/team-count', {
			params,
		})
		return data
	} catch (error: any) {
		handleAxiosError(error)
		throw error
	}
}

export default getTotalTeamCount
